// extracted by mini-css-extract-plugin
export default {"topic-container":"d5RYUMBGbp4Vm5zlA0XE"};